<template>
  <div class="page mt-3" style="display: flex;flex-direction: column;gap:1rem;">

    <SupervisionTopicModal ref="supervisionTopicModal" :supervisionId="supervisionId()" @comment-added="updateTopicComments" />

    <label class="dashboard-pages__title" v-if="this.allCheckboxes()">{{page.title}}</label>

    <b-card body-class="form__card" v-for="child_page in child_pages">

      <div class="close__element" @click="removeElement(child_page.id)" v-if="!formData.reviewee?.Id && !guest">
        <CloseIcon />
      </div>

      <div id="form-item" v-for="item in activatedItems(child_page)" :key="item.identifier">
        <div class="form-item-container">
          <FreeTextFormItem @handleTitleInput="$emit('handleTitleInput')" class="diary-title__tour reflection-title__tour" :item="item" v-if="itemActivated(item, 1)" />
          
          <!-- Debug info -->
          <div v-if="itemActivated(item, 1) && item.identifier === 'supervise'" style="color: red; font-weight: bold;">
            Item identifier: {{ item.identifier }}<br>
            Item value: {{ item.value }}<br>
            Has activated pages: {{ hasActivatedPage(item) }}<br>
            Num activated pages: {{ getActivatedPages(item).length }}
          </div>

          <LongTextFormItem :class="`${item.title === 'Introduction' ? 'reflection-intro__tour' : item.title === 'Appendix' ? 'appendix__tour' : item.title === 'References' ? 'references__tour' : ''}`" :item="item" v-else-if="itemActivated(item, 2)" />

          <DropdownFormItem :class="`${item.title === 'Governing Body' ? 'governing-body__tour' : item.title === 'Arranged In' ? 'arranged-in__tour' : item.title === 'The category this CPD activity relates to is' ? 'relates-to__tour' : item.title === 'Reflection Model' ? 'reflective-model__tour' : ''}`" :item="item" v-else-if="itemActivated(item, 4)" @valueChanged="valueChanged" />

          <div :class="`hours ${item.title === 'Number of Hours' ? 'nunber-of__hours-tour' : ''}`" v-else-if="itemActivated(item, 5) && item.title === 'Number of Hours'" >

            <HoursFormItem :item="item" v-if="item.value && item.value <= 24"/>

            <FreeTextFormItem :item="item" :type="'number'" v-else />

          </div>

          <!-- Need to hide the items that are shown on the right side of the b-card with the v-show directive -->
          <FreeTextFormItem :item="item" type="number" v-else-if="itemActivated(item, 5)" />

          <CheckboxFormItem :item="item" v-else-if="itemActivated(item, 7)" />

          <div v-else-if="itemActivated(item, 9)" :class="`${item.title === 'Start Date' ? 'start-date__tour' : item.title === 'End Date' ? 'end-date__tour' : ''}`">

            <DateFormItem :item="item" />

          </div>

          <FreeTextFormItem :item="item" type="url" v-else-if="itemActivated(item, 10)" />

          <Upload :item="item" v-else-if="itemActivated(item, 8)" class="attach-evidence__tour"/>
          
          <!-- Add activated pages under their activating form item -->
          <div v-if="hasActivatedPage(item)">
            <div v-for="activatedPage in getActivatedPages(item)" :key="activatedPage.id">
              <FormPage 
                :page="activatedPage"
                :form-data="$parent.formData"
                :guest="guest"
                :display-in-card="false"
                :subPage="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="formData.reviewee?.Id && supervision || guest">
        <b-button :class="['mt-2 mb-3 ovr-button__inverted actions-save', newComment(child_page.id) ? 'shadow-pulse' : '']" style="float:right;" @click="showComments(child_page.id)" variant="dark">
          Comments
          <CommentAlertIcon class="ml-2" v-if="newComment(child_page.id)" />
        </b-button>
      </div>

      <div v-if="shared">
        <div v-if="supervision && reviewer">
          <b-button class="mt-2 mb-0 ovr-button__inverted actions-save" style="float:right;margin-right:15px;" @click="completeTopic(child_page.id)" v-if="!topicCompleted(child_page.id)" variant="dark">Complete</b-button>
          <b-button class="mt-2 mb-0 actions-save" style="float:right;margin-right:15px;" @click="completeTopic(child_page.id)" v-if="topicCompleted(child_page.id)" variant="outline-primary">Uncomplete</b-button>
        </div>

        <div v-if="supervision && reviewee">
          <b-button class="mt-2 mb-0 ovr-button__inverted actions-save disabled" style="float:right;margin-right:15px;" v-if="topicCompleted(child_page.id)" variant="dark">Completed</b-button>
        </div>
      </div>


    </b-card>

    <div v-if="!shared && !guest">
      <b-button class="mt-2 mb-0 ovr-button__inverted actions-save" @click="addPage" variant="dark">Add {{ page.repeaterType }}</b-button>
    </div>


  </div>
</template>

<script>
    import { cloneDeep } from "lodash";
    import CloseIcon from "vue-material-design-icons/Close";
    import CommentAlertIcon from "vue-material-design-icons/CommentAlert";
    import FreeTextFormItem from './FreeTextFormItem'
    import DropdownFormItem from "./DropdownFormItem";
    import LongTextFormItem from "./LongTextFormItem";
    import DateFormItem from "./DateFormItem";
    import CheckboxFormItem from "./CheckboxFormItem";
    import Upload from "./Upload";
    import HoursFormItem from "./HoursFormItem";
    import SupervisionTopicModal from "@/components/form/SupervisionTopicModal.vue";
    import FormPage from "@/components/form/FormPage.vue";

    export default {
        name: "FormPageRepeater",
        props: ['page', 'formData','guest', 'displayInCard', 'activatedPages', 'entryId'],
        data: function () {
          return {
            child_pages:this.page.subPages ?? [],
            page_count:0
          }
        },
      mounted: function ()
      {
          this.page_copy = cloneDeep(this.page);

          if(this.page.subPages)
          {
            this.page_count = this.page.subPages.reduce((max, item) => (item.id > max ? item.id : max), -1) + 1;
          }

          if(!this.page.subPages)
          {
            this.addPage();
          }
      },
      computed:
          {
        shared: function()
        {
          return this.formData.reviewee?.Id;
        },
        supervision: function ()
        {
          return this.formData.identifier === 'supervision';
        },
        reviewee: function ()
        {
          //creator and shared with the Supervisor
          if(!this.guest && this.formData.reviewee.RevieweeType === 'Supervisor')
          {
            return true;
          }

          // guest and shared with the Supervisee
          else if(this.guest && this.formData.reviewee.RevieweeType === 'Supervisee')
          {
            return true;
          }

          return false;
        },
        reviewer: function ()
        {
          //creator and shared with the Supervisee
          if(!this.guest && this.formData.reviewee.RevieweeType === 'Supervisee')
          {
            return true;
          }
          // guest and shared with the Supervisor
          else if(this.guest && this.formData.reviewee.RevieweeType === 'Supervisor')
          {
            return true;
          }

          return false;
        }
      },
        methods: {
          supervisionId()
          {
            return this.formData.reviewee?.Id;
          },
          activatedItems: function(child_page) {

            let activated_items = this.$formTools.activatedItems(child_page, this.formData);

            if(this.guest)
            {
              activated_items.forEach((item) => {
                item.disabled = true;
              });
            }

            return activated_items;
          },
          addPage()
          {
            let page_copy = cloneDeep(this.page_copy);

            page_copy.index = this.page_count;
            page_copy.id = this.page_count;

            page_copy.title += " "+page_copy.index;
            page_copy.original = false;

            page_copy.items.push({identifier:"ID", title:"ID", value:page_copy.id});

            this.child_pages.push(page_copy);
            this.page_count++;

            this.page.subPages = this.child_pages;
          },
          topicCompleted(id)
          {
            let topics = this.formData.reviewee.Topics;

            if(!topics)
            {
              return false;
            }

            let topic = this.formData.reviewee.Topics.filter(topic => topic.TopicId == id)[0];
            if(topic.Completed === "1")
            {
              return true;
            }

          },
          completeTopic(id)
          {
            this.$api.v2.post('supervision/'+this.supervisionId()+'/'+id+'/complete', {},
    {
              headers:
              {
                'Content-Type': 'application/json'
              }
            }
            ).then((resp) =>
            {
              let topic = this.formData.reviewee.Topics.filter(topic => topic.TopicId == id)[0];
              if(topic.Completed === "1")
              {
                topic.Completed = "0";
                this.$success('Topic Uncompleted', resp.body.message);
              }
              else
              {
                topic.Completed = "1";
                this.$success('Topic Completed', resp.body.message);
              }

            }).catch((resp) =>
            {
              this.$httpError('Failed to update completion', resp);
            }).then(() =>
            {

            });
          },
          newComment: function(id)
          {
            let topic = this.formData.reviewee.Topics.filter(topic => topic.TopicId == id)[0];
            let topic_comments = topic.Comments;

            if(topic_comments && topic_comments.length > 0)
            {
              let latest_comment = topic_comments[topic_comments.length - 1];

              if(latest_comment && this.guest && this.formData.reviewee.RevieweeType !== latest_comment.CommentBy)
              {
                return true;
              }

              if(latest_comment && !this.guest && this.formData.reviewee.RevieweeType === latest_comment.CommentBy)
              {
                return true;
              }
            }


            return false;
          },
          showComments(id)
          {
            let review_type = this.formData.reviewee.RevieweeType;
            let topic = this.formData.reviewee.Topics.filter(topic => topic.TopicId == id)[0];

            let topic_title = topic.TopicTitle;
            let topic_actions = topic.TopicActions;
            let topic_comments = topic.Comments;

            this.$refs.supervisionTopicModal.show(id,topic_title,topic_actions,topic_comments,review_type,this.guest);
          },
          removeElement(id)
          {
            let removeable_index = this.child_pages.findIndex((element) => element.id === id);
            this.child_pages.splice(removeable_index, 1);

            this.page.subPages = this.child_pages;
            this.page_count = this.page.subPages.reduce((max, item) => (item.id > max ? item.id : max), -1) + 1;

          },
          valueChanged(value)
          {
            this.$emit('valueChanged', value)
          },
          allCheckboxes: function() {
              let allCheckboxes = true;
              for (let i = 0; i < this.page.items.length; i++) {
                  if (this.page.items[i].type === 7) {
                      allCheckboxes = allCheckboxes && true;
                  } else {
                      allCheckboxes = false;
                  }
              }
              return allCheckboxes;
          },
          itemActivated: function(item, expectedType) {
              return item.type === expectedType;
          },
          isEmptyObject: function(obj) {
              for(const prop in obj) {
                  if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                      return false;
                  }
              }
              return true;
          },
          updateTopicComments: function(data) {
            // Find the topic in formData
            const topicId = data.topicId;
            const updatedComments = data.comments;
            
            if (this.formData.reviewee && this.formData.reviewee.Topics) {
              const topicIndex = this.formData.reviewee.Topics.findIndex(topic => topic.TopicId == topicId);
              
              if (topicIndex !== -1) {
                // Initialize Comments array if it doesn't exist
                if (!this.formData.reviewee.Topics[topicIndex].Comments) {
                  this.$set(this.formData.reviewee.Topics[topicIndex], 'Comments', []);
                }
                
                // Update the comments array with the new comments
                this.$set(this.formData.reviewee.Topics[topicIndex], 'Comments', updatedComments);
              }
            }
          },
            // Check if a form item has activated any pages - directly check form pages
            hasActivatedPage: function(item) {
                if (!item || !item.identifier || !item.value) {
                    return false;
                }
                
                // Check if any page in the form is activated by this item
                return this.$parent.form.pages.some(page => 
                    page.requiresActivation && 
                    page.activatedBy && 
                    page.activatedBy[item.identifier] && 
                    page.activatedBy[item.identifier].includes(item.value)
                );
            },
            // Get all pages that are activated by this item - directly from form pages
            getActivatedPages: function(item) {
                if (!item || !item.identifier || !item.value) {
                    return [];
                }
                
                // Filter pages that are activated by this item
                return this.$parent.form.pages.filter(page => 
                    page.requiresActivation && 
                    page.activatedBy && 
                    page.activatedBy[item.identifier] && 
                    page.activatedBy[item.identifier].includes(item.value) &&
                    // Prevent infinite recursion
                    page.id !== this.page.id && 
                    // Don't include repeater pages 
                    !page.repeater
                );
            },
        },
        components: {
            CloseIcon,
            CommentAlertIcon,  // From vue-material-design-icons/CommentAlert (imported at line 76)
            HoursFormItem,
            Upload,
            CheckboxFormItem,
            DateFormItem,
            LongTextFormItem,
            DropdownFormItem,
            FreeTextFormItem,
            SupervisionTopicModal,
            FormPage
        }
    }
</script>

<style scoped>
label, legend {
    font-weight: bold !important;
}
.close__element
{
  float:right;
  cursor:pointer;
  transform: translateY(-75%) translateX(90%);
}

.form__card {
	background-color: #f4f7f8;
}

.disclaimer-text {
	font-weight: 600;
	display: block;
	line-height: 1.2;
}

.form-item-container {
    position: relative;
    width: 100%;
}

.activated-page-container {
    margin-left: 20px;
    padding-left: 15px;
    border-left: 2px solid #e0e0e0;
    margin-top: 10px;
    margin-bottom: 20px;
}

@keyframes pulse-shadow {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.shadow-pulse {
  animation: pulse-shadow 2s infinite;
}

</style>
